import { useEffect } from 'react';
import { prefetchReadingComprehensionExperience } from './prefetchReadingComprehension';

export function usePrefetchReadingComprehension(enabled: boolean): void {
  useEffect(() => {
    if (!enabled) return;
    prefetchReadingComprehensionExperience();
  }, [enabled]);
}
